import { BannerPlaceList } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

const name = 'bannerPlace';

const icon = 'fa-window-maximize';

export default {
    pages: {
        BannerPlaceList,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name,
    icon,
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/BannerPlace/index.ts